// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-page-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  margin: var(--spacing-small) 0;
  cursor: auto;
}
.cart-page-wrapper .cart-page-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.cart-page-wrapper .cart-page-content .cart-content-items {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  cursor: auto;
}
.cart-page-wrapper .cart-page-content .cart-content-items .cart-content-title {
  margin-bottom: var(--spacing-regular);
}
.cart-page-wrapper .cart-page-content .cart-content-items .cart-content-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: var(--font-paragraph-line) !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.cart-page-wrapper .cart-page-content .cart-content-items .cart-content-label .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: var(--font-paragraph-line) !important;
  color: var(--color-neutral-dark-darker) !important;
  cursor: auto;
}
@media screen and (max-width: 768px) {
  .cart-page-wrapper .cart-page-content .cart-content-items {
    border: 0;
    box-shadow: none;
    padding: 0;
  }
  .cart-page-wrapper .cart-page-content .cart-content-items .cart-content-label {
    display: none;
  }
  .cart-page-wrapper .cart-page-content .cart-content-items .cart-content-title {
    margin-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/cart/CartStyles.less"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AALA;EAQQ,aAAA;EACA,sBAAA;EACA,yBAAA;AAAR;AAVA;EAaY,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,YAAA;AAAZ;AAhBA;EAmBgB,qCAAA;AAAhB;AAnBA;EAsBoB,6BAAA;EACA,gBAAA;EACA,kDAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAApB;AA3BA;EAiCoB,gCAAA;EACA,gBAAA;EACA,kDAAA;EACA,kDAAA;EACA,YAAA;AAHpB;AAWA;EACI;IAGY,SAAA;IACA,gBAAA;IACA,UAAA;EAXd;EAME;IAQgB,aAAA;EAXlB;EAGE;IAYgB,gBAAA;EAZlB;AACF","sourcesContent":["// DESKTOP\n.cart-page-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-regular);\n    margin: var(--spacing-small) 0;\n    cursor: auto;\n\n    .cart-page-content {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing-small);\n\n        .cart-content-items {\n            padding: var(--spacing-regular);\n            border-radius: var(--border-radius-secondary) !important;\n            box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n            cursor: auto;\n\n            .cart-content-title {\n                margin-bottom: var(--spacing-regular);\n\n                .vert-title {\n                    font-size: var(--font-medium);\n                    font-weight: 600;\n                    line-height: var(--font-paragraph-line) !important;\n                    margin: 0;\n                    text-align: left;\n                    cursor: auto;\n                }\n            }\n\n            .cart-content-label {\n                .vert-paragraph {\n                    font-size: var(--font-paragraph);\n                    font-weight: 500;\n                    line-height: var(--font-paragraph-line) !important;\n                    color: var(--color-neutral-dark-darker) !important;\n                    cursor: auto;\n                }\n            }\n        }\n    }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n    .cart-page-wrapper {\n        .cart-page-content {\n            .cart-content-items {\n                border: 0;\n                box-shadow: none;\n                padding: 0;\n\n                .cart-content-label {\n                    display: none;\n                }\n\n                .cart-content-title {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
